declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const gaEvent = ({
  action,
  category,
  label,
  value,
  extraData,
}: {
  action: string;
  category: string;
  label: string;
  value: number;
  extraData?: Record<string, any>;
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: action,
    event_category: category,
    event_label: label,
    value: value,
    ...extraData,
  });
};
